import { Component, HostBinding, HostListener } from '@angular/core';
import { AuthenticationService } from './_core/services/authentication/authentication.service';
import { LoginService } from './_core/services/login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'e-Patrimonio';
  cssPanel = 'main-panel-full';
  deferredPrompt: any;
  showButton = false;
  @HostListener('window:beforeinstallprompt', ['$event'])
  @HostBinding('@.disabled')
  public animationsDisabled = false;
  usuarioLogado: any;
  isLogado = false;
  cssLogado = 'main-panel ps ps--active-x';

  constructor(
    public login: LoginService,
    private authenticationService: AuthenticationService) {
      
      this.authenticationService.currentUser.subscribe((usuario) => {
        if (usuario !== null) {
          this.isLogado = true;
          this.cssLogado = 'main-panel ps ps--active-x';
          this.usuarioLogado = usuario;
        } else {
          this.isLogado = false;
          this.cssLogado = '';
          this.usuarioLogado = null;
          this.cssPanel = 'main-panel-full';
        }
      });
    }
}
